import React from 'react';
import { useIdleTimer } from 'react-idle-timer';

export interface WithIdleTimerProps {
  handleIdle(): void;
}

export default (props: WithIdleTimerProps) => {
  const handleOnIdle = () => {
    props.handleIdle();
  };

  useIdleTimer({
    timeout: 1000 * 60 * 15,
    events: ['mousemove', 'keydown', 'touchmove'],
    onIdle: handleOnIdle
  });

  return <></>;
};
